import React from "react";
import GlobalFilter from "../../../Utility/GlobalFilter/GlobalFilter";

const DEFAULT_FILTERS = {
  client: "All Clients",
  module: "",
  status: "Active",
  billingType: "Both",
  dateRange: { startDate: null, endDate: null },
};

const SaasBillingFilter = ({
  filters,
  onFilterChange,
  onDateRangeChange,
  onFilterReset,
  onApplyFilters,
  clientOptions = [],
  moduleOptions = [],
}) => {
  const handleFilterReset = () => {
    if (onFilterReset) {
      onFilterReset(DEFAULT_FILTERS);
    } else {
      ["client", "module", "status", "billingType"].forEach((name) => {
        onFilterChange({
          target: {
            name,
            value: DEFAULT_FILTERS[name],
          },
        });
      });
      onDateRangeChange({ startDate: null, endDate: null });
    }
  };

  const applyFilters = () => {
    onApplyFilters?.();
  };

  const fields = [
    {
      type: "dropdown",
      name: "client",
      label: "Client",
      value: filters.client,
      options: clientOptions || [],
      placeholder: "All Clients",
      searchable: true,
      multiselect: false,
    },
    {
      type: "dropdown",
      name: "module",
      label: "Module",
      value: filters.module,
      options: moduleOptions || [],
      placeholder: "All Modules",
      preserveOptionOrder: true,
      searchable: true,
      multiselect: false,
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      value: filters.status,
      options: ["Active", "Inactive"],
      placeholder: "Active",
      searchable: false,
      multiselect: false,
    },
    {
      type: "dropdown",
      name: "billingType",
      label: "Billing Type",
      value: filters.billingType,
      options: ["Both", "Monthly", "Implementation"],
      placeholder: "Both",
      searchable: false,
      multiselect: false,
    },
    {
      type: "daterange",
      name: "dateRange",
      label: "Date Range",
      value: filters.dateRange,
      placeholder: "Select Date Range",
      onChange: onDateRangeChange,
    },
  ];

  return (
    <div className="w-full mb-4">
      <GlobalFilter
        listingFilter={filters}
        handleFilterChange={onFilterChange}
        handleFilterReset={handleFilterReset}
        applyFilters={applyFilters}
        fields={fields}
        columns={4}
        defaultExpanded={false}
        label="Filter"
      />
    </div>
  );
};

export default SaasBillingFilter;
